import { render, staticRenderFns } from "./cModalViewRequeimientoDetails.vue?vue&type=template&id=6810de15&scoped=true"
import script from "./cModalViewRequeimientoDetails.vue?vue&type=script&lang=js"
export * from "./cModalViewRequeimientoDetails.vue?vue&type=script&lang=js"
import style0 from "./cModalViewRequeimientoDetails.vue?vue&type=style&index=0&id=6810de15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6810de15",
  null
  
)

export default component.exports